import React, { Component, Suspense } from "react";
import { withRouter } from "react-router-dom";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Col, Row, Button } from "reactstrap";
import { Card } from "reactstrap";
import { Menu, Segment, Sidebar, Dropdown } from "semantic-ui-react";
import { ResponsiveBar } from "@nivo/bar";
import { BasicTooltip } from "@nivo/tooltip";
import {
  Skeleton,
  DatePicker,
  Button as ButtonAnt,
  Switch,
} from "antd";
import Fade from "react-reveal/Fade";
import { connect } from "react-redux";
import { Services } from "../../../repositories/clients/Services";
import axios from "axios";
import _ from "lodash";
import { IconNewComment } from "./components/img";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Loader from "./../../Global/Loader";
import FormFiltros from "./model/form";

import { Link } from "react-router-dom";
import "./styles.scss";
import Swal from "sweetalert2";

import { withNamespaces } from "react-i18next";
import { saveAs } from "file-saver";

import "./styles.scss";
import CountCard from "../Components/CountCard";
import { FullLoader } from "../Home/components/Loader";
import Chart from "react-google-charts";
import DataTable from "../Components/DataTable";
import { openNotification } from "../Components/Notification";

const Comments = React.lazy(() => import("../Components/Comments"));

const colors = [
  "#0045F3",
  "#0C55F6",
  "#175FF9",
  "#2369FC",
  "#2D73FF",
  "#3A7DFF",
  "#4697FF",
  "#52A1FF",
  "#5DABFF",
  "#69B5FF",
  "#75BFFF",
  "#80C9FF"
];


const dateNow = new Date();

const { RangePicker } = DatePicker;

class OrderListCommponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameXlsx: `${this.props.t("po_list")} - ${dateNow.getFullYear() +
        "" +
        (dateNow.getMonth() + 1).toString().padStart(2, "0") +
        "" +
        dateNow.getDate().toString().padStart(2, "0")
        }`,
      isMovil: false,
      loadercomments: false,
      loadingTable: false,
      viewModalComments: false,
      commentsData: [],
      users: [],
      rolId: this.props._rolId,
      userId: this.props._user,
      scrollLine: false,
      orders: [],
      data: [],
      advancedObj: [],
      catalogCombo: [],
      advancedSearch: {},
      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : "[0]",
      activePage: 1,
      limit: 10,
      numberPage: 1,
      filtros: "",
      filterOpen: false,
      url: "",
      loading: true,
      columns: [
        {
          label: "",
          id: "commentView",
          key: "commentViewAction",
          minWidth: 45,
          maxWidth: 45,
          noclick: true,
          custom: (value, triggerFn) => (
            <div
              title={this.props.t("comments")}
              onClick={() => {
                this.setState(
                  {
                    loadercomments: true,
                    viewModalComments: true,
                  },
                  () => this.getCommnets(value)
                );
              }}
            >
              {value.NewComments ? (
                <IconNewComment></IconNewComment>
              ) : (
                <span className="icon-comments icons-front-module" />
              )}
            </div>
          ),
        },
        {
          label: "",
          key: "",
          CollapseTable: true,
          flatColor: true,
          keydatavalidate: "Status",
          minWidth: 30,
          maxWidth: 30,
        },
        {
          label: "",
          key: "PriorityPO",
          minWidth: 45,
          maxWidth: 45,
          custom: (value) => {
            return value.PriorityPO === '1' && (
              <span className="icon-priority-shipments icons-front-module orange" title={this.props.t("priority_po")} />
            );
          },
        },
        {
          label: "",
          key: "Issue",
          minWidth: 45,
          maxWidth: 45,
          custom: (value) => {
            return value.Issue === '1' && (
              <span className="icon-po-priorities icons-front-module" title={this.props.t("po_management_list_priority_issue")} />
            );
          },
        },
        {
          label: this.props.t("po_no"),
          key: "PONumber",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => (
            <Link
              to={"/po-detail-view/" + value.POId}
              className="underline-link"
            >
              {value.PONumber}
            </Link>
          ),
        },
        {
          label: this.props.t("status"),
          key: "StatusPo",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => {
            return <span className={value.StatusIdPo !== 71 ? "badge badge-euro" : "badge badge-euro-created"}>{value.StatusPo}</span>;
          },
        },
        { label: this.props.t("company"), key: "CustomerName", minWidth: 200 },
        { label: this.props.t("shipper"), key: "SupplierName", minWidth: 200 },
        {
          label: this.props.t("consignee"),
          key: "ConsigneeName",
          minWidth: 200,
        },
        {
          label: this.props.t("transport_mode"),
          key: "TransportMode",
          minWidth: 180,
        },
        // { label: 'Incoterm', key: 'Incoterm', minWidth: 100 },
        // { label: 'Peso bruto', key: 'GrossWeight', minWidth: 150 },

        // { label: 'Descripción general de la mercancía', key: 'DescriptionGoods', minWidth: 150 },
        // { label: 'Tramo contratado', key: 'FreightTerm', minWidth: 150 },

        {
          label: this.props.t("required_at_destination"),
          key: "requireddestinationdate",
          minWidth: 180,
        },
        { label: this.props.t("creation"), key: "createdate", minWidth: 150 },
      ],

      subTable: [
        { label: this.props.t("item_line"), key: "LineID", minWidth: 120 },
        { label: this.props.t("item_no"), key: "ItemNo", minWidth: 120 },
        {
          label: this.props.t("item_description"),
          key: "Description",
          minWidth: 250,
          limitString: 50,
        },
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => (
            // <Button  className={value.StatusId === 13 ? 'btn-estatus btn-oval _gray_button' : ' btn-estatus btn-oval'} color={mapColor[value.StatusId] ? mapColor[value.StatusId] : 'complementary'} onClick={() => { }}>{value.Status}</Button>
            <span class="badge badge-euro">{value.Status}</span>
          ),
        },

        {
          label: this.props.t("item_qty_ordered"),
          key: "QTYOrdered",
          minWidth: 120,
        },
        {
          label: this.props.t("item_qty_confirmed"),
          key: "QTYConfirmed",
          minWidth: 120,
        },
        {
          label: this.props.t("item_request_charge"),
          key: "RequiredCagoReady",
          minWidth: 150,
        },
        {
          label: this.props.t("item_promised_charge"),
          key: "PromiseCargoReady",
          minWidth: 200,
        },
        {
          label: this.props.t("item_real_charge"),
          key: "ActualCargoReady",
          minWidth: 150,
        },
      ],
      searchOnInit: false,
      searchText: "",
      POId: 0,
      openComments: false,
      handleResCom: "unset",
      isSearchComments: true,
      tableLoader: false,
      totalCardsInfo: [],
      totalCardsConf: [
        {
          id: 1,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: 'bg-maritimo',
          image: <span className="icon-active-orders icons-cards-totals"></span>,
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
        {
          id: 2,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: 'bg-maritimo',
          image: <span className="icon-confirm icons-cards-totals"></span>,
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
        {
          id: 3,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: 'bg-maritimo',
          image: <span className="icon-delay icons-cards-totals"></span>,
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
        {
          id: 4,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: 'bg-tcc',
          image: <span className="icon-priority-shipments icons-cards-totals"></span>,
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
      ],
      totalStatus: [],
      creationTendency: [],
      maxTendencia: 0,
      orderHeaders: [
        this.props.t("po_no"),
        this.props.t("status"),
        this.props.t("company"),
        this.props.t("shipper"),
        this.props.t("consignee"),
        this.props.t("transport_mode"),
        this.props.t("required_at_destination"),
        this.props.t("creation"),
        this.props.t("line"),
        this.props.t("item"),
        this.props.t("item_description"),
        this.props.t("status"),
        this.props.t("qty_ordered"),
        this.props.t("qty_confirmed"),
        this.props.t("uom"),
        this.props.t("request_ready"),
        this.props.t("promise_ready"),
        this.props.t("real_charge"),
      ],
      orderKeys: [
        "PONumber",
        "StatusPo",
        "CustomerName",
        "SupplierName",
        "ConsigneeName",
        "TransportMode",
        "RequiredDestinationDate",
        "createdate",
        "LineID",
        "ItemNo",
        "Description",
        "Status",
        "QTYOrdered",
        "QTYConfirmed",
        "UOMCode",
        "RequiredCagoReady",
        "PromiseCargoReady",
        "ActualCargoReady",
      ],
      priorityChecked: false,
      extraFilter: "",
      buttonLoadPO: ['1', '2', '3', '5', '6', '9'].includes(props._rolId) ?
        <div className="float-right">
          <UncontrolledDropdown>
            <DropdownToggle
              caret
              color="primary"
              className="d-flex align-items-center"
              title={this.props.t("create_new")}
            >
              {this.props.t("po_management_upload")}
            </DropdownToggle>
            <DropdownMenu right>
              {['1', '2', '3'].includes(props._rolId) && (
                <DropdownItem onClick={() => this.props.history.push("/load-po-ia")}>
                  <span className="icon-ia-azul icon-button-add" />
                  {this.props.t("po_management_upload_ia")}
                </DropdownItem>
              )}
              <DropdownItem onClick={() => this.props.history.push("/load-po")}>
                <span className="icon-po-manual icon-button-add" />
                {this.props.t("po_management_upload_manual")}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
        : false,
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMovil: isMobileDevice,
    });

    await this.createFilter();
    await this.getOrdersList();
    await this.getGraphicInfo();
    await this.getCatalogs();
    this.GenerateExtraFilter();
  };

  getCommnets = (item, NewComments) => {
    let { CustomerId } = item;
    let moduleId = 10;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    axios
      .get(
        `${Services.ORDEN_SERV.path}orderComents/get-comment?rowid=${item.POId}&moduleid=${moduleId}&general=false&zona=${timezone}&lang=${this.props.lng}`
      )
      .then((response) => {
        let comentario = response.data.Comment;
        this.getUserMenciones(comentario, CustomerId, item.POId, item);

        if (NewComments) {
          openNotification('success', NewComments);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUserMenciones = (comentario, CustomerId, ShipmentId, item) => {
    let { userId } = this.state;

    axios
      .get(
        `${Services.ORDEN_SERV.path}orderComents/getUserMension?CustomerId=${CustomerId}&user=${userId}`
      )
      .then((response) => {
        this.setState({
          commentsData: comentario,
          users: response.data.data,
          rowid: ShipmentId,
          itemCommenSelect: item,
          loadercomments: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  newMessage = async (data) => {
    let { userId, rowid, itemCommenSelect } = this.state;
    data.Rowid = rowid;
    data.UserId = userId;
    data.ModuleId = 10;


    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.ORDEN_SERV.path}orderComents/add-comment`, data)
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_saved")
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteMessage = async (idDelete, toggle) => {
    let { itemCommenSelect } = this.state;

    axios
      .delete(
        `${Services.ORDEN_SERV.path}orderComents/delete-comment/${idDelete}`
      )
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_deleted")
        );
        toggle()
      })
      .catch((error) => {
        console.log(error);
      });
  };

  setOrderSearch = (value) => {
    if (this.state.search === value) return;

    this.setState(
      {
        search: value,
        activeInvoicePage: 1,
        numberPageInvoice: 1,
        numberPage: 1,
        loading: true,
      },
      () => {
        this.getOrdersList();
      }
    );
  };
  createFilter = async () => {
    let { advancedSearch } = this.state;
    advancedSearch = FormFiltros.map((filtro) => {
      return {
        id: filtro.id,
        options: filtro.options,
        isDate: filtro.type === "Datetime",
        UseIN: filtro.type === "Select",
        value: "",
        type: filtro.type,
        label: filtro.label,
        name: filtro.name,
        class: filtro.class,
        style: filtro.style,
      };
    });
    this.setState({ advancedSearch });
  };

  sendMessage = (text, type) => {
    Swal.fire({
      icon: type,
      confirmButtonColor: "#0561fc",
      confirmButtonText: "Ok",
      html: `<div class="text-center euro-title-form">
      ${text}
      </div>`,
      customClass: {
        confirmButton: 'custom-width-btn swal'
      }
    });
  };

  resetAdvance = () => {
    let { advancedSearch, priorityChecked } = this.state;
    advancedSearch.map((advData) => {
      if (advData.type === "Datetime") {
        advData.value = "";
        advData.valueD = "";
      } else if (advData.id === "PriorityPO") {
        advData.value = priorityChecked ? 1 : 0;
      } else {
        advData.value = [];
      }
      return advData;
    });
    this.setState({ advancedSearch, loading: true }, () => {
      this.getOrdersList();
      this.generateFilters();
    });
  };
  generateFilters = () => {
    let { catalogCombo, advancedSearch } = this.state;
    let { t } = this.props;
    let Inputs = [];

    Inputs.push(
      advancedSearch.map((e, i) => {
        if (e.type === "Select")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  {t(e.label)}
                  {e.required === true ? (
                    <span style={{ color: "#ff0000" }}>*</span>
                  ) : (
                    ""
                  )}
                </span>
              </Fade>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <Select
              id={e.id}
              required
              type={e.datatype}
              name={e.name}
              value={advancedSearch[e.id]}
              onChange={this.handleChangeSelect(e.id)}
              options={catalogCombo[e.options]}
              
            /> */}

                <Dropdown
                  className="NewClass"
                  onChange={this.handleChangeSelect(e.id)}
                  id={e.id}
                  options={catalogCombo[e.options]}
                  clearable
                  search
                  selection
                  fluid
                  value={e.value}
                  multiple
                  allowAdditions
                  noResultsMessage={t("no_results_found")}
                />
              </div>
            </div>
          );
        // else if (e.type === "Datetime") return (
        //   <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
        //     <Fade left opposite>
        //       {" "}
        //       <span id={e.id} style={e.style}>
        //         <label>
        //           {e.label}{" "}
        //           {e.required === true ? (
        //             <span style={{ color: "#ff0000" }}>*</span>
        //           ) : (
        //             ""
        //           )}
        //         </label>
        //       </span>
        //     </Fade>
        //     <div style={{ display: "flex", alignItems: "center" }}>
        //       <DatePicker
        //         className="search-drops"
        //         placeholder={e.label}
        //         id={e.id}
        //         format={e.format}
        //         value={advancedSearch[e.id]}
        //         onChange={this.handleChangeDate(e.id)}
        //       />
        //     </div>
        //   </div>
        // )
        else if (e.type === "Datetime") {
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                <span id={t(e.label)} style={e.style}>
                  {" "}
                  <label>
                    {t(e.label)} {e.required == true ? <span>*</span> : ""}{" "}
                  </label>
                </span>
              </Fade>
              <RangePicker
                onChange={this.handleChangeDate(e.id)}
                size="middle"
                className="col-md-12"
                value={e.valueD}
                placeholder={[t("start_date"), t("end_date")]}
              // style={{ maxWidth: "60%" }}
              />
              {/* <Datetime
            required
            type={e.datatype}
            inputProps={{ className: 'form-control', id: e.id }}
            value={Filter[e.id]}
            onChange={this.handleChangeDate(e.id)}
          /> */}
              <Fade left opposite>
                <label style={e.style}>{e.error}</label>
              </Fade>
            </div>
          );
        }
      })
    );
    let NewInput = (
      <div className="row">
        <div className="col-12">
          <span className="icon-clear icons-front-module float-right"
            title={t("eliminate_filter")}
            onClick={this.resetAdvance}
          />
          {/* <em
            class="fa-2x mr-2 float-right fas fa-eraser"
            style={{
              marginTop: "7px",
              cursor: "pointer",
              textAlign: "end",
            }}
            title={t("eliminate_filter")}
            onClick={this.resetAdvance}
          /> */}
        </div>
        {Inputs}
      </div>
    );
    this.setState({
      filtros: NewInput,
    });
  };

  handleChangeSelect = (selected) => (evt, data) => {
    let { advancedSearch } = this.state;
    if (data.value) {
      advancedSearch.map((search) => {
        if (search.id == selected) {
          search.value = data.value;
        }
      });
    } else {
      advancedSearch.map((search) => {
        if (search.id == selected) {
          search.value = "";
        }
      });
    }
    this.setState({ advancedSearch, numberPage: 1, loading: true }, () => {
      this.generateFilters();
      this.getOrdersList();
    });
  };

  handleChangeDate = (name) => (event) => {
    let { advancedSearch } = this.state;

    try {
      advancedSearch.map((search) => {
        if (search.id == name) {
          let init = event ? event[0].format("YYYY-MM-DD") : "";
          let end = event ? event[1].format("YYYY-MM-DD") : "";
          search.value = { init, end };
          search.valueD = event ? [event[0], event[1]] : "";
          search.isDate = true;
        }
      });
      this.setState({ advancedSearch, numberPage: 1 }, () => {
        this.generateFilters();
        this.getOrdersList();
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  getCatalogs = async () => {
    let { catalogCombo } = this.state;
    let data = {
      client: this.state.clientesSelect,
      userId: this.state.userId,
      lang: this.props.lng,
    };
    try {
      let success = await axios.post(
        `${Services.PURCHASE_ORDER.path}purchaseOrder/filterCatalog`,
        data
      );
      catalogCombo = success.data.data;
      this.setState(
        {
          catalogCombo,
          loading: false,
        },
        () => {
          this.generateFilters();
        }
      );
    } catch (error) {
      console.warn(error);
    }
  };

  GenerateExtraFilter = () => {
    let { extraFilter, priorityChecked } = this.state;
    extraFilter = (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          marginLeft: "10px",
        }}
      >
        <span
          // src={priorityShipmentURL}
          title={this.props.t("filter_priority_po")}
          className="icon-priority-shipments icons-front-module orange"
        // width="15px"
        // alt="priority_po"
        // height="15px"
        />

        <Switch
          className="form-input-switch"
          checked={priorityChecked}
          onChange={this.handlePriorityChange}
          style={{ marginLeft: "1em" }}
        ></Switch>
      </div>
    );
    this.setState({ extraFilter });
  };

  handlePriorityChange = (event) => {
    let { advancedSearch, priorityChecked } = this.state;
    priorityChecked = event;
    let obj = advancedSearch.find((adv) => {
      return adv.id === "PriorityPO";
    });
    if (!obj) {
      advancedSearch.push({ id: "PriorityPO", val: "", UseIN: false });
    }
    advancedSearch.map((adv) => {
      if (adv.id === "PriorityPO") {
        if (event) {
          adv.value = 1;
        } else {
          adv.value = 0;
        }
      }
      return adv;
    });

    this.setState({ advancedSearch, priorityChecked }, () => {
      this.GenerateExtraFilter();
      this.getOrdersList();
    });
  };

  /*=============================================
  =            Get Order List                   =
  =============================================*/

  getGraphicInfo = async () => {
    let { clientesSelect, userId, lang } = this.state;
    try {
      let params = { customers: clientesSelect, userId, lang: this.props.lng };
      let respGraph = await axios.post(
        `${Services.PURCHASE_ORDER.path}purchaseOrder/graphicList`,
        params
      );

      this.setState(
        {
          totalCardsInfo: respGraph.data.totalInfo,
          totalStatus: respGraph.data.totalStatus,
        },
        () => {
          this.obtieneTendenciaCreacion(respGraph.data.creationTendency);
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  obtieneTendenciaCreacion = async (data) => {
    let { tendenciaData, maxTendencia } = this.state;

    tendenciaData = [["x", this.props.t("tooltip_chart_tendency")]];
    data[0].data.map((mes) => {
      tendenciaData.push([mes[0], parseInt(mes[1])]);
      if (parseInt(mes[1]) > maxTendencia) {
        maxTendencia = mes.total;
      }
    });
    this.setState({ creationTendency: tendenciaData, maxTendencia });
  };

  obtieneEstatusOrdenes = (data) => {
    var estatus = [];
    var colorInicial = "#0045F3";
    data.map((value) => {
      // if (value.estatus !== 'Creado' && value.estatus !== 'En tránsito a destino') {
      estatus.push({
        nombre: value.estatus,
        total: parseInt(value.total),
        color: colorInicial,
        extra: "",
      });
      colorInicial = this.colores(colorInicial);
      // }
    });
    let EstatusTendencia = [
      [
        "Element",
        "Total",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    try {
      estatus.map((value) => {
        const element = value;
        EstatusTendencia.push([
          element.nombre,
          element.total,
          element.color,
          element.extra,
        ]);
      });
      return EstatusTendencia;
    } catch (error) {
      return EstatusTendencia;
    }
  };

  hex = (c) => {
    var s = "0123456789abcdef";
    var i = parseInt(c);
    if (i == 0 || isNaN(c)) return "00";
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
  };
  convertToHex = (rgb) => {
    return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
  };
  trim = (s) => {
    return s.charAt(0) == "#" ? s.substring(1, 7) : s;
  };

  convertToRGB = (hex) => {
    var color = [];
    color[0] = parseInt(this.trim(hex).substring(0, 2), 16);
    color[1] = parseInt(this.trim(hex).substring(2, 4), 16);
    color[2] = parseInt(this.trim(hex).substring(4, 6), 16);
    return color;
  };
  colores = (startHex) => {
    var start =
      this.convertToRGB(startHex); /* The beginning of your gradient */
    var end = this.convertToRGB("#FFFFFF"); /* The end of your gradient */

    var alpha = 0.7; /* Alpha blending amount */
    var c = [];

    // for (var i = 0; i < len; i++) {

    c[0] = start[0] * alpha + (1 - alpha) * end[0];
    c[1] = start[1] * alpha + (1 - alpha) * end[1];
    c[2] =
      start[2] * alpha +
      (1 - alpha) * end[2]; /* Set the background color of this element */
    // console.log("convertToHex", this.convertToHex(c));
    // start = c;
    // }
    return "#" + this.convertToHex(c);
  };

  getOrdersList = async () => {
    let sendData = {};
    //limpiar valores
    if (this.state.advancedObj && this.state.advancedObj.length > 0) {
      this.state.advancedObj.map((obj) => {
        if (obj.UseIN) {
          let data = [];
          if (obj.value && obj.value.length > 0) {
            obj.value.map((d) => {
              data.push(d.split("_")[0]);
            });
          }
          obj.value = _.cloneDeep(data);
        }
      });
    }
    sendData = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      limit: this.state.limit,
      EsDTA: 0,
      search: this.state.search,
      query: { allData: false, noGroup: false },
      advanced: this.state.advancedSearch,

      lang: this.props.lng,
      userId: this.state.userId,
    };
    this.setState({
      url: encodeURI(
        `${Services.PURCHASE_ORDER.path}purchaseOrder/listPurchaseOrders?search=${this.state.search}&allData=true`,
        {
          lang: this.props.lng,
          userId: this.state.userId,
        }
      ),
      paramsxml: sendData,
      loading: true,
    });

    // // axios.post(`${Services.Get_Traceability_Shipments.path}shipments/listShipments`, data, {params:{pag:this.state.numberPage,limit:this.state.limit, EsDTA:0, search: this.state.search}} ).then(success => {

    try {
      let success = await axios.post(
        `${Services.PURCHASE_ORDER.path}purchaseOrder/listPurchaseOrders`,
        sendData
      );
      let data = success.data.data.map((e) => {
        let TraspormodeId = 1;
        e.TraspormodeId = TraspormodeId;
        e.QTYOrderedFormatted = Number(e.QTYOrdered).toLocaleString("En-us");
        return e;
      });

      this.setState({
        totalPages: success.data.totalPage,
        totalPagesExt: success.data.totalPage,
        data: data,
        dataAux: data,
        dataOut: data,
        loading: false,
        // loadingTable: false,
        // fullLoader: true
      });
    } catch (error) {
      console.log(error);
      console.warn(error);
      this.setState({
        loading: false,
        // loadingTable: false,
        // fullLoader: true
      });
    }
  };

  generateOrderExcel = () => {
    this.setState({
      excelInvoiceLoading: true,
    });

    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      limit: this.state.limit,
      EsDTA: 0,
      search: this.state.search,
      query: {
        allData: true,
        noGroup: true,
      },
      advanced: this.state.advancedSearch,

      lang: this.props.lng,
      userId: this.state.userId,
    };

    axios
      .post(
        `${Services.PURCHASE_ORDER.path}purchaseOrder/listPurchaseOrders`,
        data
      )
      .then((success) => {
        let data = success.data.data;
        /**
         * Se convierte a flotante para que en el excel se tome en cuenta como numero
         */
        if (data && data.length > 0) {
          data.map((d) => {
            d.TotalAmount = parseFloat(d.TotalAmount);
            return d;
          });
        }
        let titleDownload = this.state.nameXlsx;
        let info = {
          config: {},
        };

        let options = {
          headers: this.state.orderHeaders,
          keys: this.state.orderKeys,
          image: {
            name: "euro",
          },
          sheetName: this.props.t("orders"),
          font: 'SF Pro Display',
        };
        if (!data || data.length === 0) {
          throw new Error("No hay datos para exportar");
        }
        axios
          .post(`${Services.REPORT.path}report/dynamic/xlsx`, {
            info,
            data,
            options,
          })
          .then((success) => {
            if (success.data.base64) {
              const fileName = titleDownload + ".xlsx";
              const linkSource = `data:application/xlsx;base64,${success.data.base64}`;
              saveAs(linkSource, fileName);
            } else throw new Error("Error al generar el excel");
          });
      })
      .catch((_error) => {
        openNotification('error', this.props.t("excel_export_fails"));
      })
      .finally(() => {
        this.setState({
          excelInvoiceLoading: false,
        });
      });
  };
  resetTable = () => {
    this.setState({ isSearchComments: false, handleResCom: "unset" }, () => {
      this.getOrdersList();
    });
  };

  changePage = (e, { activePageOrder }) => {
    this.setState(
      {
        numberPage: activePageOrder,
        loading: true,
      },
      () => {
        this.getOrdersList();
      }
    );
  };

  /*=============================================
  =            Selected Order                   =
  =============================================*/

  selectedOrder = (order) => {
    this.setState({
      POId: order.POId,
      PONumber: order.PONumber,
      openComments: true,
      handleResCom: "set",
      isSearchComments: true,
    });
  };

  handleClose = () => {
    this.setState({ openComments: false, isSearchComments: false });
  };

  setAdvanced = () => {
    let { filterOpen } = this.state;
    this.setState({ filterOpen: !filterOpen }, () => { });
  };

  getTotalChartsData = () => {
    let { totalStatus } = this.state;
    const data = totalStatus.map((item, index) => {
      let obj = {};
      obj[item.estatus] = item.total;
      obj.id = item.estatus;
      if (colors[index]) {
        obj.color = colors[index];
      } else {
        obj.color = "#0045F3";
      }
      return obj;
    });
    return data.reverse();
  };

  getTotalChartsKeys = () => {
    let { totalStatus } = this.state;
    const keys = totalStatus.map((item) => item.estatus);
    return keys;
  };

  getTotalChartsColors = () => {
    let { totalStatus } = this.state;
    let colorInicial = "#0045F3";
    const colors = totalStatus.map((_item) => {
      let color = colorInicial;
      colorInicial = this.colores(colorInicial);
      return color;
    });
    return colors;
  };
  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      viewModalComments,
      loadercomments,
      commentsData,
      itemCommenSelect,
      users,
      rolId,
      userId,
      scrollLine,
      data,
      columns,
      loading,
      filtros,
      isMovil,
      totalCardsConf,
      totalCardsInfo,
      creationTendency,
      maxTendencia,
      loadingTable,
      buttonLoadPO,
    } = this.state;

    return (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-po-management icon-header" />
          {this.props.t("purchase_orders")}
        </div>
        <CountCard config={totalCardsConf} data={totalCardsInfo} />
        <div className="row">
          <div className="col-xs-12 col-md-6 .col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  {this.props.t("total_by_status")}
                </div>
              </div>
              <div className="card-body" style={{ overflow: "hidden" }}>
                {loading ? (
                  <FullLoader />
                ) : (
                  <ResponsiveBar
                    data={this.getTotalChartsData()}
                    keys={this.getTotalChartsKeys()}
                    tooltip={(item) => {
                      return (
                        <BasicTooltip
                          id={item.data.id}
                          value={item.data[item.data.id]}
                          color={item.data.color}
                          enableChip
                        />
                      );
                    }}
                    margin={{ top: 20, right: 40, bottom: 50, left: 130 }}
                    padding={0.15}
                    layout="horizontal"
                    valueScale={{ type: "linear" }}
                    indexScale={{ type: "band", round: true }}
                    colors={colors}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", 1.6]],
                    }}
                    theme={{
                      axis: {
                        fontSize: "11px",
                        fontFamily: "SF Pro Display",
                        tickColor: "#000a2e",
                        ticks: {
                          line: {
                            stroke: "#000a2e",
                          },
                          text: {
                            fill: "#000a2e",
                            fontSize: '11px',
                            fontFamily: "SF Pro Display",
                          },
                        },
                        legend: {
                          text: {
                            fill: "#000a2e",
                            fontSize: "11px",
                            fontFamily: "SF Pro Display",
                          },
                        },
                      },
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 25,
                      // legend: 'country',
                      legendPosition: "middle",
                      legendOffset: 32,
                      format: (value) => (value.length > 17 ? `${value.substring(0, 17)}...` : value), // Truncar a 10 caracteres
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      // legend: 'food',
                      legendPosition: "middle",
                      legendOffset: -40,
                      format: (value) => (value.length > 17 ? `${value.substring(0, 17)}...` : value), // Truncar a 10 caracteres

                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{
                      from: "color",
                      modifiers: [["darker", 1.6]],
                    }}
                    enableLabel={false}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 .col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  {this.props.t("creation_tendency")}
                </div>
              </div>
              <div className="card-body" style={{ overflow: "hidden" }}>
                {loading ? (
                  <FullLoader />
                ) : (
                  <div id="chartDashboard">
                    <Chart
                      style={{
                        width: "100%",
                      }}
                      className={"valueTable"}
                      // chartType="AreaChart"
                      chartType="LineChart"
                      loader={<div>Loading Chart</div>}
                      data={creationTendency}
                      options={{
                        width: "100%",
                        height: "300px",
                        curveType: "function",
                        legend: {
                          position: "none",
                        },
                        tooltip: { isHtml: true },
                        vAxis: {
                          minValue: 0,
                          viewWindow: { min: 0, max: maxTendencia + 1 },
                          textStyle: {
                            fontSize: 12,
                            color: "#000a2e",
                            fontName: "SF Pro Display"
                          },
                        },
                        hAxis: {
                          textStyle: {
                            fontSize: 12,
                            color: "#000a2e",
                            fontName: "SF Pro Display"
                          },
                        },
                        pointSize: 5,
                        series: {
                          0: {
                            color: "#000a2e",

                            lineWidth: 2,
                          },
                        },
                      }}
                      rootProps={{ "data-testid": "1" }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Card className="myCard">
          {/* <CardBody> */}
          {loading ? (
            <Loader />
          ) : (
            <div>
              <Row>
                <Col md={12} xl={12}>
                  <Suspense fallback={<div>Loading...</div>}>
                    <Sidebar.Pushable as={Segment}>
                      <Sidebar
                        as={Menu}
                        animation="overlay"
                        icon="labeled"
                        style={{
                          maxHeight: "84%!important",
                          width: isMovil
                            ? window.innerWidth - window.innerWidth * 0.09
                            : 400,
                        }}
                        // style={{ maxHeight: "84%!important" }}
                        direction="right"
                        // onHide={() => setVisible(false)}
                        vertical
                        id="sidebarComents"
                        visible={viewModalComments}
                        className="custom-sidebar"
                      // width={window.innerWidth < 993 ? 'wide' : 'very wide'}
                      >
                        {/* <CardBody> */}
                        <div className=" col-12 close_container">
                          <div className="header_comments">
                            {itemCommenSelect
                              ? itemCommenSelect.PONumber
                              : ""}
                          </div>
                          <div
                            className="close_icon2"
                            onClick={() => {
                              this.setState({ viewModalComments: false });
                            }}
                          >
                            <ButtonAnt
                              size="small"
                              type="primary"
                              shape="circle"
                            >
                              X
                            </ButtonAnt>
                          </div>
                        </div>
                        <div style={{ height: "3em" }} className=" col-12">
                          {" "}
                        </div>

                        {loadercomments ? (
                          <Skeleton active paragraph={{ rows: 17 }} />
                        ) : (
                          <div className="col-12">
                            <Comments
                              commentTableList={true}
                              rolId={rolId}
                              userId={userId}
                              data={commentsData}
                              catalogs={users}
                              scrollLine={scrollLine}
                              funtionNewMessage={this.newMessage}
                              funtionDeleteMessage={this.deleteMessage}
                            />
                          </div>
                        )}
                      </Sidebar>
                      <Sidebar.Pusher>
                        <Segment basic>
                          <DataTable
                            // loadingTable={loadingTable}
                            downloadExcel={this.generateOrderExcel}
                            excelLoading={this.state.excelInvoiceLoading}
                            labelSelected={""}
                            search={this.state.search}
                            filtrosPanel={filtros}
                            startSubTable={1}
                            paddingSubtable="3%"
                            colspanSubTable={8}
                            showExcel={true}
                            panel={true}
                            data={data}
                            columnsTable={columns}
                            subTable={this.state.subTable}
                            handleSearch={this.setOrderSearch}
                            activePage={this.state.numberPage}
                            pages={this.state.totalPages}
                            OnPageChange={this.changePage}
                            sumaryInfo={this.state.sumaryInfo}
                            ExtraFilter={this.state.extraFilter}
                            customButton={buttonLoadPO} />
                        </Segment>
                      </Sidebar.Pusher>
                    </Sidebar.Pushable>
                  </Suspense>
                </Col>
              </Row>
            </div>
          )}
        </Card>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
  lang: state.header.lang,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderListCommponent))
);
